import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  LinearProgress,
  Menu,
  MenuItem,
  ListItemIcon,
  Divider,
  Box,
  Grid,
  useTheme,
  styled, Icon,
} from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import InfoIcon from "@mui/icons-material/Info";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import LanguageIcon from '@mui/icons-material/Language';
import DashboardIcon from "@mui/icons-material/Dashboard";
import Exposure from "@mui/icons-material/Exposure";
import DescriptionIcon from "@mui/icons-material/Description";
import { useNavigate, useLocation } from "react-router-dom";
import { NaturePeopleOutlined } from "@mui/icons-material";

// import Logotipo from "assets/DOC/icons/DS_Logo.svg";
import Logotipo from "assets/icon_Metlife_Header.jpg";
import { persistence } from "../store/persistence";
import { SelectLanguage, UseImage } from "./";
import ConfigurationComponent from "../pages/Configuration/ConfigurationComponent";
import { ClearSession, IsDevice } from "../utils";
import { makeStyles } from "@mui/styles";

import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  imgClass: {
    // padding: "0.5 em",
    width: "30% !important",
    height: "85% !important",
    [theme.breakpoints.only("xs")]: {
      width: "100% !important",
      // maxHeight: "54px",
    },
    // [theme.breakpoints.only("sm")]: {
    //   width: "100% !important",
    //   // maxHeight: "54px",
    // },
    // [theme.breakpoints.only("md")]: {
    //   width: "100% !important",
    //   // maxHeight: "54px",
    // },
    // [theme.breakpoints.only("lg")]: {
    //   width: "100% !important",
    //   // maxHeight: "54px",
    // },
  },
  appBar: {
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2) !important", // Box shadow
    marginBottom: theme.spacing(2), // Margin bottom
  },
}));

const ToolbarCustom = styled(Toolbar)(({ theme }) => ({
  minHeight: "68px !important",
  maxHeight: "70px !important",
  // 'MuiToolbar-root':{
  //     minHeight: '48px !important',
  // }
}));

export const CustomCounterAppBar = (props) => {
  const theme = useTheme();
  const location = useLocation();
  const classes = useStyles();
  const [progress, setProgress] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isAutoconsumo, setIsAutoconsumo] = useState(null);
  const [sessionData, setSessionData] = useState("");
  const [userName, setUserName] = useState("");
  const [openConfig, setOpenConfig] = useState(false);

  const auth = useSelector((state) => state.Authentication);
  const titleCurrent = useSelector((state) => state.AddTitleLegoData)?.Title;
  const navigate = useNavigate();
  const {IsMobile} = IsDevice()

  const { t } = useTranslation();
  const isBrasilEnvironment = process.env.REACT_APP_ENVIRONMENT === "BRADEV" || process.env.REACT_APP_ENVIRONMENT === "BRA"


  // console.log("auth ", auth);

  useEffect(() => {
    // console.log("...........auth is sessionStorage.getItem(AuthData)...........", localStorage.getItem('AuthData'))
    if (auth.items == undefined || auth.items == null) {
      // console.log("...........auth is null...2........", auth)
      // console.log("...........auth is sessionStorage.getItem(AuthData)...........", localStorage.getItem('AuthData'))
    }
  }, [auth.items]);

  useEffect(() => {
    setSessionData(persistence.GetSession());
    // setProgressValues()
    // console.log("-------------******APPBAR auth.items..: ", auth.items)
    if (auth.items != undefined) {
      if (
        auth.items.UserLoginData.SecurityLoginData.Roles[0].Name ==
        "Usuario Autoconsumo"
      ) {
        setIsAutoconsumo(true);
      } else if (
        auth.items.UserLoginData.SecurityLoginData.Roles[0].Name == "Agente"
      ) {
        setIsAutoconsumo(false);
      }
    }
  }, [props]);

  useEffect(() => {
    // console.log("APP HEADER sessionData: ", localStorage.getItem('IsAutoconsumo'))
    settingUserName();
  }, [sessionData]);

  let settingUserName = () => {
    setUserName(sessionStorage.getItem("userName"));
    setIsAutoconsumo(localStorage.getItem("IsAutoconsumo"));
  };

  let setProgressValues = () => {
    let initial = parseInt(localStorage.getItem("CurrentStageGroup"));
    let ending = parseInt(localStorage.getItem("TotalStageGroups"));
    let totalProgress = (initial * 100) / ending;
    setProgress(totalProgress);
  };

  let handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  let handleMenu = (type) => {
    setAnchorEl(null);
    switch (type) {
      case 2:
        navigate("/main/AboutComponent");
        break;
      case 3:
        navigate("/main/SearchResultComponent");
        break;
      case 4:
        // sessionStorage.clear()
        // localStorage.clear()
        ClearSession();
        persistence.EndSession();
        navigate("/auth/");
        break;
      case 5:
        navigate("/main/DashboardComponent");
        break;
      case 6:
        navigate("/main/CreditSimulatorComponent");
        break;
      case 7:
        //TODO: implementar modal window.oopen para manual
        let wihe =
          "width=" +
          window.screen.availWidth +
          ",height=" +
          window.screen.availHeight;
        window.open(
          `https://techhub.docsolutions.com/TECHHUB/ManualAVIS.pdf`,
          "_blank",
          "screenX=1,screenY=1,left=1,top=1," + wihe
        );
        break;
      default:
        break;
    }
  };

  let handleOpenConfig = (event) => {
    // alert("Configuracion")
    setOpenConfig(true);
  };

  let handleCloseConfig = (event) => {
    // alert("Configuracion")
    setOpenConfig(false);
  };

  return (
    <AppBar
      className={classes.appBar}
      position="sticky"
      sx={{
        backgroundColor: "#ffffff !important",
        zIndex: "5 !important",
      }}
      color="transparent"
      elevation={0}
    >
      <ToolbarCustom>
        <Grid
          container
          spacing={1}
          justifyContent="flex-start"
          sx={{ mt: 0, mb: 0 }}
        >
          <Grid
            item
            xs={3}
            sm={3}
            sx={{
              m: 0,
              mt: 1,
              padding: 0,
              display: "flex",
              flexDirection: "row",
              "&.MuiGrid-item": {paddingTop: 0}
            }}
          >
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={() => handleMenu(0)}
            >
              <MenuItem onClick={() => handleMenu(1)}>
                <ListItemIcon>
                  <AccountCircleIcon fontSize="small"/>
                </ListItemIcon>
                {userName}
              </MenuItem>
              <Divider/>
              <MenuItem onClick={() => handleMenu(2)}>
                <ListItemIcon>
                  <InfoIcon fontSize="small"/>
                </ListItemIcon>
                {t("about")}
              </MenuItem>
              {!isAutoconsumo && (
                <MenuItem onClick={() => handleMenu(3)}>
                  <ListItemIcon>
                    <SearchIcon fontSize="small"/>
                  </ListItemIcon>
                  {t("general_search")}
                </MenuItem>
              )}
              {/* {!isAutoconsumo && (
                <MenuItem onClick={() => handleMenu(5)}>
                  <ListItemIcon>
                    <DashboardIcon fontSize="small" />
                  </ListItemIcon>
                  Dashboard
                </MenuItem>
              )}
              {!isAutoconsumo && (
                <MenuItem onClick={() => handleMenu(7)}>
                  <ListItemIcon>
                    <DescriptionIcon fontSize="small" />
                  </ListItemIcon>
                  Manual
                </MenuItem>
              )} */}
              <MenuItem onClick={() => handleMenu(4)}>
                <ListItemIcon>
                  <ExitToAppIcon fontSize="small"/>
                </ListItemIcon>
                {t("log_out")}
              </MenuItem>
            </Menu>

            <IconButton
              edge="start"
              sx={{
                height: "30px",
                width: "30px",
                "&:focus": {
                  outline: "none !important",
                },
              }}
              color="inherit"
              aria-label="menu"
              onClick={handleClick}
            >
              <MenuIcon color="action"/>
            </IconButton>
            {props.viewReturn != undefined && props.viewReturn ? (
              <IconButton
                edge="start"
                color="inherit"
                aria-label="return"
                onClick={props.backAction}
              >
                <ArrowBack color="action"/>
              </IconButton>

            ) : null}
            {/* <Box sx={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'flex-start'
                        }}>
                            {props.viewMenu === undefined || props.viewMenu ?
                                props.ActiveConfig ? <UseImage
                                    src={Logotipo}
                                    className={classes.imgClass}
                                    onClick={handleOpenConfig} /> :
                                    <UseImage
                                        src={Logotipo}
                                        className={classes.imgClass}
                                    />
                                : <UseImage
                                    src={Logotipo}
                                    className={classes.imgClass}
                                    onClick={handleOpenConfig} />
                            }
                        </Box> */}
            {props.viewButtonClose != undefined && props.viewButtonClose ? (
              <CloseIcon onClick={props.closeClick}/>
            ) : null}
            <img src={Logotipo} alt={'Metlife Logo'} style={{height: '2.5rem', marginLeft:'1rem'}}/>
            <ConfigurationComponent
              open={openConfig}
              close={handleCloseConfig}
            />
          </Grid>
          <Grid
            item
            xs={6}
            sm={6}
            sx={{
              m: 0,
              mt: 1.5,
              padding: 0,
              "&.MuiGrid-item": { paddingTop: 0 },
            }}
          >
            <Typography variant="h6" gutterBottom align="center">
              {titleCurrent}
            </Typography>
          </Grid>
          <Grid
            item
            xs={!IsMobile ? 2 : 3}
            sm={3}
            sx={!IsMobile ? {
              m: 0,
              display: 'flex',
              justifyContent: "center",
              alignContent: 'center',
              gap:'3px',
              // "&.MuiGrid-item": { paddingTop: 0 },
            } : {
              position: "absolute",
              right: 20
            }}
          >
            {/* <LanguageIcon fontSize={"large"}/> */}
            {!isBrasilEnvironment ? <SelectLanguage size={'small'}/> : null}
          </Grid>
        </Grid>
      </ToolbarCustom>

      {props.initialStep != null &&
        props.initialStep != undefined &&
        props.endingStep != null &&
        props.endingStep != undefined && (
          <LinearProgress
            variant="buffer"
            value={progress}
            valueBuffer={progress}
            sx={{
              height: "6px !important",
              borderRadius: "30px !important",
              marginLeft: "24px",
              marginRight: "24px",
              "&.MuiLinearProgress-colorPrimary:not(.MuiLinearProgress-buffer)":
                {
                  backgroundColor: theme.palette.primary.barra,
                },
              "& .MuiLinearProgress-colorPrimary": {
                backgroundColor: theme.palette.primary.barra,
              },
              "& .MuiLinearProgress-barColorPrimary": {
                backgroundColor: theme.palette.primary.barra,
              },
              "& .MuiLinearProgress-dashedColorPrimary": {
                animation: `none`,
                backgroundImage: `none !important`,
                backgroundColor: `#E0E0E0 !important`,
              },
            }}
          />
        )}
      {/* {props.initialStep != null && props.initialStep != undefined && props.endingStep != null && props.endingStep != undefined &&
                <Typography
                    className={classes.appBarTypo}
                    variant="caption"
                    display="block"
                    gutterBottom>
                    &nbsp; Paso {props.initialStep} de {props.endingStep}
                </Typography>
            } */}
    </AppBar>
  );
};
